var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 18V16.3333C14.1673 15.4493 13.8161 14.6014 13.191 13.9763C12.5659 13.3512 11.718 13 10.834 13H4.16732C3.28326 13 2.43542 13.3512 1.8103 13.9763C1.18517 14.6014 0.833984 15.4493 0.833984 16.3333V18",
    stroke: "#FFF8EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 9.66667C9.3403 9.66667 10.8327 8.17428 10.8327 6.33333C10.8327 4.49238 9.3403 3 7.49935 3C5.6584 3 4.16602 4.49238 4.16602 6.33333C4.16602 8.17428 5.6584 9.66667 7.49935 9.66667Z",
    stroke: "#FFF8EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.166 18.0001V16.3334C19.1655 15.5948 18.9196 14.8774 18.4672 14.2937C18.0147 13.7099 17.3811 13.293 16.666 13.1084",
    stroke: "#FFF8EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 3.1084C14.051 3.29198 14.6865 3.70898 15.1403 4.29366C15.5942 4.87833 15.8405 5.59742 15.8405 6.33757C15.8405 7.07771 15.5942 7.7968 15.1403 8.38147C14.6865 8.96615 14.051 9.38315 13.334 9.56673",
    stroke: "#FFF8EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteUsers);
export default __webpack_public_path__ + "static/media/whiteUsers.66999df2dcc85cd0e5a21196ae13c023.svg";
export { ForwardRef as ReactComponent };